export default __webpack_public_path__ + "static/media/2020-2021 Annual Financial Statement.4accf38a.pdf";